import { Grid } from '@mui/material'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import { default as InputMultiline } from 'components/FormInput'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import React, { useCallback, useEffect, useState } from 'react'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import genericService from 'services/generic.service'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../contexts/hearing-identification-block-fields.context'
import FormInputNumber from 'components/FormInputNumber'

type StudyingGroupProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

const REASON_EVASION_OTHER_OPTION_ID = '2'

export const StudyingGroup: React.FC<StudyingGroupProps> = ({ control, watch, setValue }) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()

  const [scapeTimeOptions, setScapeTimeOptions] = useState<ItemOption[]>([])
  const [scapeReasonOptions, setScapeReasonOptions] = useState<ItemOption[]>([])

  const isStudying = watch('identificacaoAdolescente.estaEstudando')
  const reasonEvasionValue = watch('identificacaoAdolescente.idMotivoEvasao')

  const fillInputSelect = useCallback(async (): Promise<void> => {
    try {
      const [resScapeTimeOptions, resScapeReasonOptions] = await Promise.all([
        genericService.get('/tempo-evasao').then((res) => res.data),
        genericService.get('/motivo-evasao').then((res) => res.data),
      ])

      setScapeTimeOptions(resScapeTimeOptions)
      setScapeReasonOptions(resScapeReasonOptions)
    } catch (err) {
      console.error('Input select Requests: ', err)
    }
  }, [setScapeTimeOptions, setScapeReasonOptions])

  useEffect(() => {
    fillInputSelect()
  }, [fillInputSelect])

  useEffect(() => {
    if (isStudying === 'E') {
      setValue('identificacaoAdolescente.anoConclusaoEstudo', null)
    } else if (isStudying === 'C') {
      setValue('identificacaoAdolescente.idTempoEvasao', '')
      setValue('identificacaoAdolescente.idMotivoEvasao', '')
      setValue('identificacaoAdolescente.descricaoMotivoEvasao', '')
      setValue('identificacaoAdolescente.procuradoEscola', '')
      setValue('identificacaoAdolescente.procuradoConselhoTutelar', '')
    } else {
      setValue('identificacaoAdolescente.idTempoEvasao', '')
      setValue('identificacaoAdolescente.idMotivoEvasao', '')
      setValue('identificacaoAdolescente.descricaoMotivoEvasao', '')
      setValue('identificacaoAdolescente.procuradoEscola', '')
      setValue('identificacaoAdolescente.procuradoConselhoTutelar', '')
      setValue('identificacaoAdolescente.anoConclusaoEstudo', null)
    }
  }, [isStudying])

  return (
    <>
      <Grid item lg={isStudying === 'N' ? 3 : 12} xs={12}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.estaEstudando'
          label='Está estudando?'
          options={[
            {
              label: 'Sim',
              value: 'S',
            },
            {
              label: 'Evadiu',
              value: 'E',
            },
            {
              label: 'Concluiu',
              value: 'C',
            },
          ]}
          disabled={isBlockedFields}
        />
      </Grid>
      {isStudying === 'E' && (
        <>
          <Grid item lg={3} xs={12} flexDirection={'row'} alignContent={'end'}>
            <FormInputSelect
              control={control}
              name='identificacaoAdolescente.idTempoEvasao'
              label='Tempo de evasão'
              options={scapeTimeOptions}
            />
          </Grid>
          <Grid item lg={6} xs={12} flexDirection={'row'} alignContent={'end'}>
            <FormInputSelect
              control={control}
              name='identificacaoAdolescente.idMotivoEvasao'
              label='Motivo da evasão'
              options={scapeReasonOptions}
            />
          </Grid>
          {reasonEvasionValue && String(reasonEvasionValue) === REASON_EVASION_OTHER_OPTION_ID && (
            <Grid item lg={6} xs={12} flexDirection={'row'} alignContent={'end'}>
              <InputMultiline
                control={control}
                name='identificacaoAdolescente.descricaoMotivoEvasao'
                label='Descreva o motivo da evasão'
                maxLength={210}
                placeholder='Descreva Aqui...'
                multiline
                minRows={3}
                required={String(reasonEvasionValue) === REASON_EVASION_OTHER_OPTION_ID}
              />
            </Grid>
          )}
          <Grid item xl={2} lg={3} xs={6} flexDirection={'row'} alignContent={'end'}>
            <FormControlRadio
              control={control}
              name='identificacaoAdolescente.procuradoEscola'
              label='Foi procurado pela escola?'
              options={radioButtonChoiceOptions}
            />
          </Grid>
          <Grid item lg={3} xs={6} flexDirection={'row'} alignContent={'end'}>
            <FormControlRadio
              control={control}
              name='identificacaoAdolescente.procuradoConselhoTutelar'
              label='Foi procurado pelo Conselho Tutelar?'
              options={radioButtonChoiceOptions}
            />
          </Grid>
        </>
      )}
      {isStudying === 'C' && (
        <>
          <Grid item lg={3} xs={12}>
            <FormInputNumber
              control={control}
              name='identificacaoAdolescente.anoConclusaoEstudo'
              label='Ano de conclusão'
            />
          </Grid>
        </>
      )}
    </>
  )
}
